<template>
        <div class="meals">
                <div class="panel panel-default card-view panel-refresh" v-for="(meal, key) in food_data.meals" :key="key">
                        <div class="refresh-container">
                                <div class="la-anim-1"></div>
                        </div>
                        <div class="panel-heading">
                                <div class="pull-left">
                                        <h4 class="panel-title txt-light">{{key.replace("_", " ")}}</h4>
                                </div>
                                <div class="pull-right" style="color:white;">
                                        <span>
                                                {{food_data["nutrient_" + key].calories}}
                                        </span>
                                </div>
                                <div class="clearfix"></div>
                        </div>
                        <div class="panel-wrapper collapse in">
                                <div class="panel-body">
                                        <div v-for="(item, index) in meal" v-bind:key="index">
                                                <span class="pull-left inline-block capitalize-font txt-dark">
                                                        <a style="font-weight:600; color:#7EC347" href="javascript:void(0);"  data-toggle="modal" data-target="#recipeDetailsModal" v-if="item.ingredient == null" @click="loadRecipeDetails(item.recipe.id)" v-html="item.recipe.name"></a>
                                                        <span v-if="item.ingredient != null" v-html="item.ingredient.html_name"></span>
                                                        <br/>
                                                        <span style="font-size:12px; color:#999;">{{item.servings}} {{item.ingredient_measurement.measurement_name}}</span>
                                                </span>
                                                <span class="pull-right">{{item.nutrients.calories.toFixed(2)}}&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0)" class="trash" title="Delete" data-toggle="modal" @click="temp_id = item.id" data-target="#exampleModal" >
                                                                <i class="fa fa-trash"></i>
                                                        </a>
                                                </span>
                                                <div class="clearfix"></div>
                                                <hr class="light-grey-hr row mt-10 mb-10">
                                        </div>
                                        <p v-show="Object.keys(meal).length == 0">No food has been logged yet.</p>
                                </div>
                                <div class="panel-body text-right">
                                        <router-link :to="'add-food/' + key.replace('_', ' ')" class="btn btn-nutri-green btn-xs">+ Add Food</router-link>
                                </div>
                        </div>
                </div>
                <!-- Weight Settings Modal -->
		<div id="recipeDetailsModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content" v-if="chosenRecipe">
                                        <div style="width:100%; height:200px; background-size:cover; background-position:center" :style="{'background-image': 'url(' + chosenRecipe.photo_url + ')'}">
                                        </div>
					<div class="modal-body">
						<div class="modal-header-icon">
							<h4>{{chosenRecipe.name}}</h4>
						</div>
                                                <div class="col-md-12 mt-20 mb-30">
                                                        <div class="col-md-4 text-center">
                                                                <h6>Prep time</h6>
                                                                <p>{{chosenRecipe.preparation_time}}</p>
                                                        </div>
                                                        <div class="col-md-4 text-center">
                                                                <h6>Cooking time</h6>
                                                                <p>{{chosenRecipe.cooking_time}}</p>
                                                        </div>
                                                        <div class="col-md-4 text-center">
                                                                <h6>Serves</h6>
                                                                <p>{{chosenRecipe.servings}}</p>
                                                        </div>
                                                </div>
                                                <div class="col-md-12">
                                                        <h6>Ingredients</h6>
                                                        <ul>
                                                                <li v-for="(ingredient, index) in chosenRecipe.ingredients" :key="index">{{ingredient.specified_qty}} {{ingredient.measurements_data[ingredient.specified_measurement].measurement_name}} of {{ingredient.html_name}}</li>
                                                        </ul>
                                                </div>
                                                <div class="col-md-12 mt-30">
                                                        <h6>Instructions</h6>
                                                        <div v-html="chosenRecipe.instruction_steps">
                                                        </div>
                                                </div>
                                                <!-- <div class="col-md-12 mt-30">
                                                        <h6>Nutrients per Serving</h6>
                                                        <NutritionalTrafficLight 
                                                                v-if="chosenRecipe" 
                                                                :calories="chosenRecipe.nutrients_per_serving[1] != null ? chosenRecipe.nutrients_per_serving[1].per_serving : 0" 
                                                                :totalFat="chosenRecipe.nutrients_per_serving[4] != null ? chosenRecipe.nutrients_per_serving[4].per_serving : 0" 
                                                                :saturatedFat="chosenRecipe.nutrients_per_serving[5] != null ? chosenRecipe.nutrients_per_serving[5].per_serving : 0"
                                                                :sugars="chosenRecipe.nutrients_per_serving[11] != null ? chosenRecipe.nutrients_per_serving[11].per_serving : 0" 
                                                                :sodium="chosenRecipe.nutrients_per_serving[12] != null ? chosenRecipe.nutrients_per_serving[12].per_serving : 0" 
                                                                :energyKj="chosenRecipe.nutrients_per_serving[2] != null ? chosenRecipe.nutrients_per_serving[2].per_serving : 0">
                                                                </NutritionalTrafficLight>
                                                </div> -->
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-nutri-red" data-dismiss="modal" ref="newMealPlanClose">Close</button>
					</div>
				</div>
				<!-- /.modal-content -->
			</div>
			<!-- /.modal-dialog -->
		</div>
                <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLabel">Delete Record</h5>
				</div>
				<div class="modal-body">
					Are you sure you want to delete this meal record?
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
					<button type="button" class="btn btn-nutri-green" data-dismiss="modal" @click="deleteFoodTracking(temp_id)">Okay</button>
				</div>
				</div>
			</div>
		</div>
		<!-- /.modal -->
        </div>
</template>

<script>
import API from "../../../services/api.js";
import NutritionalTrafficLight from '../../../components/common/TrafficLights.vue';
const api = new API();
export default {
        components:{
                NutritionalTrafficLight
        },
        name: "nutrivitas-meals",
        props:[
		'fooddata'
	],
	data() {
		return {
                        food_data: this.fooddata,
                        editing_item: null,
                        chosenQuantity: null,
                        chosenMeasurement: null,
                        chosenNutrients:[],
                        chosenRecipe:null,
                        temp_id: 0,
		}
	},
	created() {
	},
	methods: {
                deleteFoodTracking(id){
			api.deleteFoodTracking(id).then(async response => {
				swal("Food Tracking Record Deleted!", "", "success");
				this.$parent.getFoodsForToday();
			});
                },
                loadRecipeDetails(id){
                        api.getRecipeDetails(id).then(async response => {
				this.chosenRecipe = response.data.data;
			});
                },
        },
        watch: {
                'editing_item': function(){
                        let chosenNutrients = [];
                        for(var n in this.editing_item.nutrients){
                                chosenNutrients[n] = this.editing_item.nutrients[n];
                        }
                        this.chosenNutrients = chosenNutrients;
                },
        }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/FoodTracking/components/Meals.vue